import { useState } from "react";

const punctuationRegex = /[.,;:'"!?()[\]{}`~@#$%^&*+\-=_\\|/<>]/;

export const useDictation = () => {
  const [diagnosisInsertStart, setDiagnosisInsertStart] = useState<
    number | null
  >(null);
  const [diagnosisInsertEnd, setDiagnosisInsertEnd] = useState<number | null>(
    null
  );
  const [microscopicInsertStart, setMicroscopicInsertStart] = useState<
    number | null
  >(null);
  const [microscopicInsertEnd, setMicroscopicInsertEnd] = useState<
    number | null
  >(null);
  const [noteInsertStart, setNoteInsertStart] = useState<number | null>(null);
  const [noteInsertEnd, setNoteInsertEnd] = useState<number | null>(null);

  const insertDictation = (
    field: string,
    text: string,
    textToInsert: string
  ) => {
    let before = text;
    let after = "";
    let currentText = "";
    let insertStart: number | null = null;
    let insertEnd: number | null = null;

    switch (field) {
      case "diagnosis":
        insertStart = diagnosisInsertStart;
        insertEnd = diagnosisInsertEnd;
        break;

      case "microscopic":
        insertStart = microscopicInsertStart;
        insertEnd = microscopicInsertEnd;
        break;

      case "note":
        insertStart = noteInsertStart;
        insertEnd = noteInsertEnd;
        break;
    }

    currentText = text;

    if (insertStart !== null && insertEnd !== null) {
      before = text.slice(0, insertStart);
      after = text.slice(insertEnd);
    } else {
      before = text.slice(0, currentText?.length || 0);
    }

    // Check if the last character in 'before' is punctuation
    const lastCharIsPunctuation = punctuationRegex.test(before.slice(-1));

    const middle = lastCharIsPunctuation
      ? textToInsert
      : textToInsert.trimStart();
    const finalText = before + middle + after;

    // Update the start and end points for the next run
    switch (field) {
      case "diagnosis":
        setDiagnosisInsertStart(before.length);
        setDiagnosisInsertEnd(before.length + middle.length);
        break;

      case "microscopic":
        setMicroscopicInsertStart(before.length);
        setMicroscopicInsertEnd(before.length + middle.length);
        break;

      case "note":
        setNoteInsertStart(before.length);
        setNoteInsertEnd(before.length + middle.length);
        break;
    }

    return finalText;
  };

  return {
    insertDictation,
    setDiagnosisInsertStart,
    setDiagnosisInsertEnd,
    setMicroscopicInsertStart,
    setMicroscopicInsertEnd,
    setNoteInsertStart,
    setNoteInsertEnd,
  };
};
